import { useOnlineStatusContext } from "../context/OnlineStatusContext";

/**
 * Hook for accessing user online status.
 *
 * Provides:
 * - `getStatus(userId)` — returns `{ isOnline, lastSeenAt }` for the given user
 * - `fetchStatuses(userIds)` — fetches and caches bulk status from the server
 *
 * Usage:
 * ```ts
 * const { getStatus, fetchStatuses } = useOnlineStatus();
 *
 * useEffect(() => {
 *   fetchStatuses([userId1, userId2]);
 * }, [fetchStatuses]);
 *
 * const { isOnline, lastSeenAt } = getStatus(userId);
 * ```
 */
export function useOnlineStatus() {
  return useOnlineStatusContext();
}
